// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2zm3_","actions":"GroupTable_actions__3PJOZ","deleteModalFooter":"GroupTable_deleteModalFooter__p5i1H"};